import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
  latLng,
  Map,
  MapOptions,
  marker,
  tileLayer,
  icon,
  Marker,
  Browser
} from 'leaflet';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit, OnChanges {

  private _map: Map;

  constructor() { }

  ngOnInit() {
    this.initMap();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  get options(): MapOptions {
    return {
      layers: [
        tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          opacity: 0.7,
          maxZoom: 17,
          detectRetina: true,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }),
        marker([44.914726, 9.0286393], {
          icon: icon({
            iconSize: [101, 51],
            iconAnchor: [13, 41],
            iconUrl: `assets/club-house/logo_black.png`,
          })
        }),
        marker([44.9171467, 9.0302811], {
          icon: icon({
            iconSize: [41, 41],
            iconAnchor: [13, 41],
            iconUrl: `assets/naki/logo_black.png`,
          })
        }),
      ],
      zoomControl: false,
      touchZoom: true,
      // dragging: !Browser.mobile,
      zoom: 18,
      center: latLng([44.9160558, 9.029529])
    };
  }

  initMap() {
    this._updatePosition();
  }

  onMapReady(map: Map) {
    this._map = map;
    setTimeout(() => {
      map.invalidateSize();
    }, 1000);
  }

  private _updatePosition() {
    if (this._map) {
      setTimeout(() => {
        this._map.invalidateSize();
      }, 1000);
      this._map.flyTo(latLng([44.9160558, 9.029529]), 18);
    }
  }

}
